import React, { useMemo } from 'react';
import StyledBox from 'views/rebranded-module/common/components/Logical/LayoutV2/FooterV2/FooterLinks/FooterLinks.styles';
import { Box, Typography } from '@mui/material';
import { ImgBox } from 'views/common/components';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import { useTranslation } from 'next-i18next';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import Typography500 from 'views/common/components/UI/Typography500';

const FooterLinks = () => {
  const { t } = useTranslation('common_layout_v2');
  const appNavigator = useAppNavigator();
  const firstFooterLinks = useMemo(() => {
    const footerLinkUTM = { ref: 'footer', sourcePage: appNavigator.pathname };
    return [
      {
        items: [
          {
            label: t('common_layout_v2:locations'),
            path: PATHS.locations(footerLinkUTM),
          },
          {
            label: t('common_layout_v2:tours'),
            path: PATHS.motorcycleTours.index(footerLinkUTM),
          },
          {
            label: t('common_layout_v2:rentals_link'),
            path: PATHS.motorcycleRental(footerLinkUTM),
          },
          {
            label: t('common_layout_v2:eagleShare'),
            path: PATHS.eagleshare('/', appNavigator.locale, {
              ref: 'eaglerider-footer',
              sourcePage: appNavigator.pathname,
            }),
          },
          {
            label: t('common_layout_v2:faqs_link'),
            path: PATHS.faqs.index(footerLinkUTM),
          },
          {
            label: t('common_layout_v2:about'),
            path: PATHS.aboutUs(footerLinkUTM),
          },
          {
            label: t('common_layout_v2:eaglerider_information.contact_us'),
            path: PATHS.contactUs(footerLinkUTM),
          },
        ],
      },
      {
        items: [
          {
            label: t('common_layout_v2:franchise_opportunities'),
            path: PATHS.franchise.index(footerLinkUTM),
          },
          {
            label: t('common_layout_v2:affiliate_opportunities'),
            path: PATHS.affiliateProgram(footerLinkUTM),
          },
          {
            label: t('common_layout_v2:careers'),
            path: PATHS.careers(footerLinkUTM),
          },
        ],
      },
    ];
  }, []);

  const secoundFooterLinks = useMemo(() => {
    const footerLinkUTM = { ref: 'footer', sourcePage: appNavigator.pathname };
    return [
      {
        items: [
          {
            label: t(
              'common_layout_v2:eaglerider_information.terms_and_conditions',
            ),
            path: PATHS.rentals.rentalTerms(footerLinkUTM),
            smallLink: true,
          },
          {
            label: t('common_layout_v2:privacy_policy'),
            path: PATHS.privacyPolicy(footerLinkUTM),
            smallLink: true,
          },
          {
            label: t('common_layout_v2:other_information'),
            path: PATHS.information(footerLinkUTM),
            smallLink: true,
          },
        ],
      },
    ];
  }, []);
  const mobileApps = [
    {
      id: 1,
      src: '/imgs/appAD/AppStore.png',
      alt: t('common_layout_v2:download_on_app_store'),
      path: PATHS.app.ios,
    },
    {
      id: 2,
      src: '/imgs/appAD/GooglePlay.png',
      alt: t('common_layout_v2:get_on_google_play'),
      path: PATHS.app.playStore,
    },
  ];

  return (
    <StyledBox>
      <NavigatorLink href={PATHS.home()}>
        <Box className="FLLogo">
          <ImgBox
            image={{
              src: '/imgs/Rebranding/logos/vertical-light.svg',
              alt: 'ER-logo',
            }}
            imgHeight="100%"
            imgWidth="100%"
          />
        </Box>
      </NavigatorLink>
      <Box className="FLLinksContainer">
        {firstFooterLinks.map((footerLink) => (
          <Box className="FLLinksRowContainer">
            {footerLink.items.map((item) => (
              <Box>
                <NavigatorLink
                  className="FLLink"
                  variant={item.smallLink ? 'body3' : 'body1'}
                  href={item.path}>
                  {item.label}
                </NavigatorLink>
              </Box>
            ))}
          </Box>
        ))}
        {secoundFooterLinks.map((footerLink) => (
          <Box className="FLLinksRowContainer">
            {footerLink.items.map((item) => (
              <Box>
                <NavigatorLink
                  className="FLLink"
                  variant={item.smallLink ? 'body3' : 'body1'}
                  href={item.path}>
                  {item.label}
                </NavigatorLink>
              </Box>
            ))}
          </Box>
        ))}
        <Typography500 component="span" variant="body3" className="FLCopyRight">
          {t('common_layout_v2:copyright_text', {
            year: new Date().getFullYear(),
          })}
        </Typography500>
      </Box>
      <Box className="FLDownloadBtnsContainer">
        <Typography component="span" variant="body2">
          {t('common_layout_v2:get_app')}
        </Typography>
        <Box className="FLDownloadBtns">
          {mobileApps.map((item) => (
            <NavigatorLink key={item.id} href={item.path}>
              <ImgBox
                className="FLDownloadBtn"
                imgHeight="32px"
                imgWidth="95px"
                image={{
                  src: item.src,
                  alt: item.alt,
                }}
                objectFit="contain"
              />
            </NavigatorLink>
          ))}
        </Box>
      </Box>
    </StyledBox>
  );
};

export { FooterLinks };
